import { type ComparedSpecification } from '~/domains/compare';

export const filterComparedProductSpecifications = (
  comparedProductSpecifications: ComparedSpecification[],
): ComparedSpecification[] => {
  return comparedProductSpecifications
    .map((specification) => specification.withUnmatchedFeatures())
    .filter((specification) => specification.hasFeatures());
};
